module.exports = __webpack_public_path__ + "static/media/VorteileImg.cb667a9b.png";